import request from '@/helper/axiosUtil';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { toast } from 'react-toastify';

export default function usePatch(props) {
	const { url, validate, method = 'patch', showError = true, isAuth = true } = props;
	const qClient = useQueryClient();

	const action = (data) => {
		let currUrl = `/${url}/`;
		if (!isAuth) currUrl = `/${url}`

		if (data?.patchId) {
			currUrl += `${data.patchId}/`
			delete data.patchId;
		}
		let headers = null
		if (method !== 'delete') {
			headers = { 'Content-Type': 'application/json' }
		}
		if (props.type === 'form-data') {
			headers = { 'Content-Type': 'multipart/form-data' }
		}
		if (props.responseType) headers.responseType = props.responseType
		let dt = { url: currUrl, method, data, headers, isAuth }
		if (!dt.data) delete dt.data

		return request(dt);
	};

	return useMutation({
		mutationFn: (data, params = {}) => action(data, params),
		onSuccess: (res) => {
			if ([200, 201, 204].includes(res.status) && props.callback && typeof props.callback === 'function') {
				props.callback(res);
			} else if ([400, 401, 403, 404, 405, 406, 408, 413, 500, 501, 502, 503, 504, 505].includes(res.response?.status)) {
				if (props.onError && typeof props.onError === 'function') {
					props.onError(res.response);
				} else {
					toast.error(`${res.response.status} - ${res.response.statusText}`);
				}
			} else if (res.response?.data) {
				if (props.onError && typeof props.onError === 'function') {
					props.onError(res.response);
				}

				const d = res.response.data;
				if (showError && !d.data?.includes('html')) {
					Object.keys(d).forEach((k) => {
						toast.error(d[k]?.length ? (typeof d[k] === 'string' ? d[k] : d[k][0]) : d[k] || 'Error');
					});
				}
			} else if (res.name === 'AxiosError') {
				toast.error(`${res.code} - ${res.message}`);
			}
		},
		onError: (err) => {
			if (err.response.data) {
				const d = err.response.data;
				Object.keys(d).forEach((k) => {
					toast.error(d[k] || 'Error');
				});
			} else if (err.name === 'AxiosError') {
				toast.error(`${err.code} - ${err.message}`);
			}
		},
		onSettled: () => {
			validate?.forEach((val) => qClient.invalidateQueries(val));
		},
	});
}
